module.exports = __webpack_public_path__ + "static/emoji1-5c04e7052dd4bf8f910527a0197b9aef.gif";